"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true
  });
  const testimonials = [{
    author: "Jane D.",
    quote: "An unforgettable luxury adventure that perfectly blended culture and nature. Truly exceptional service!",
    position: "Travel Blogger",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/testimonial_jane_travel_blogger.png"
  }, {
    author: "Michael R.",
    quote: "EcoLuxMaya provided a seamless, personalized experience that exceeded our expectations.",
    position: "Luxury Traveler",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/testimonial_michael_luxury_traveler.png"
  }, {
    author: "Sophie L.",
    quote: "The eco-luxury tours were breathtaking. Every detail was thoughtfully curated for an extraordinary experience.",
    position: "Adventure Seeker",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/testimonial_sophie_adventure_seeker.png"
  }, {
    author: "Carlos M.",
    quote: "From cenote exploration to sunset cruises, EcoLuxMaya delivered memories that will last a lifetime.",
    position: "Photography Enthusiast",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/testimonial_carlos_photography_enthusiast.png"
  }];
  return <section id="testimonials" ref={sectionRef} className="dark bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden">
      <div className="container mx-auto max-w-7xl">
        <div className={`text-center mb-12 transition-all duration-[var(--duration-slow)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-4 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
            What Our Guests Say
          </h2>
          <p className="text-dark-foreground/80 text-lg max-w-2xl mx-auto">
            Discover why travelers from around the world choose EcoLuxMaya for
            their Riviera Maya adventures.
          </p>
        </div>

        <div className={`relative transition-all duration-[var(--duration-slow)] ease-[var(--ease-spring)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/2">
                  <div className="h-full p-8 rounded-2xl bg-dark-section/50 backdrop-blur-sm border border-white/10 shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:shadow-strong hover:-translate-y-1">
                    <div className="flex flex-col md:flex-row gap-6 items-start">
                      <SafeHydrate><Avatar className="size-20 shrink-0 ring-2 ring-primary/30">
                        <AvatarImage src={testimonial.image} alt={testimonial.author} />
                        <AvatarFallback className="bg-primary/20 text-primary text-xl font-semibold">
                          {testimonial.author.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>

                      <div className="flex-1 space-y-4">
                        <Quote className="size-8 text-secondary/60" />
                        <p className="text-dark-foreground/90 italic text-base leading-relaxed font-light">
                          "{testimonial.quote}"
                        </p>
                        <div className="pt-2 border-t border-white/10">
                          <p className="font-semibold text-dark-foreground">
                            {testimonial.author}
                          </p>
                          <p className="text-sm text-dark-foreground/60">
                            {testimonial.position}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            <div className="flex justify-center gap-4 mt-8">
              <CarouselPrevious className="relative left-0 top-0 translate-x-0 translate-y-0 bg-primary/10 border-primary/30 text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-fast)]" />
              <CarouselNext className="relative right-0 top-0 translate-x-0 translate-y-0 bg-primary/10 border-primary/30 text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-fast)]" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}